// #7 Termo de Encerramento (FP-CMP-009) — dispositivo da decisão (kind + tally,
// ambos CLEARTEXT) + datas. A fundamentação integral (cifrada) fica manual.

import type { FormBlock } from './form-pdf.js';
import { manualField } from './form-pdf.js';
import {
  type FormInput,
  categoriaLabel,
  competenciaLabel,
  decisaoLabel,
  fmtDate,
  memberLabel,
  getDecisao,
} from './forms-common.js';

export function buildEncerramento(input: FormInput): FormBlock[] {
  const decisao = getDecisao(input.state);
  const closedAt = 'closedAt' in input.state ? input.state.closedAt : null;

  const blocks: FormBlock[] = [
    { kind: 'title', text: 'Termo de Encerramento' },
    { kind: 'section', text: 'Identificação' },
    { kind: 'field', label: 'Processo (protocolo):', value: input.caseId },
    { kind: 'field', label: 'Categoria:', value: categoriaLabel(input.categoria) },
    { kind: 'field', label: 'Comitê de competência:', value: competenciaLabel(input.categoria) },
    { kind: 'section', text: 'Resultado' },
    {
      kind: 'field',
      label: 'Decisão:',
      value: decisao ? decisaoLabel(decisao.kind) : '',
    },
  ];

  if (decisao) {
    blocks.push({
      kind: 'table',
      headers: ['Voto', 'Quantidade'],
      rows: [
        ['Procedente', String(decisao.votoTally.procedente)],
        ['Improcedente', String(decisao.votoTally.improcedente)],
        ['Imp. por insuficiência', String(decisao.votoTally.improcedente_insuficiencia)],
      ],
    });
    blocks.push(
      { kind: 'field', label: 'Data da decisão:', value: fmtDate(decisao.emittedAt) },
      { kind: 'field', label: 'Relator:', value: memberLabel(input.members, decisao.emittedBy) },
      {
        kind: 'field',
        label: 'Prazo recursal até:',
        value: fmtDate(decisao.prazoRecursalAteEpochMs),
      },
    );
  }

  blocks.push({
    kind: 'field',
    label: 'Data de encerramento:',
    value: closedAt === null ? '' : fmtDate(closedAt),
  });

  blocks.push(
    { kind: 'section', text: 'Fundamentação' },
    manualField('Fundamentação da decisão:'),
    { kind: 'spacer', mm: 6 },
    { kind: 'signature', nome: '', papel: 'Relator / Comitê de apuração' },
  );

  return blocks;
}
